module.exports = __webpack_public_path__ + "img/logo_login.79105b71.png";